import React from 'react';
import styled from 'styled-components';
import { func, string, object, oneOfType, bool } from 'prop-types';

import Wrapper from '../Wrapper';
import Text from '../Text/Text';
import Button from '../Button';
import Row from '../Container/Row';
import Column from '../Container/Column';
import Image from '../Image';

const TitleLabel = styled(Text)`
  color: ${({ theme }) => theme.colors.darkBlack};
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 8px;
  text-align: center;
`;

const DescriptionLabel = styled(Text)`
  color: ${({ theme }) => theme.colors.greyDark};
  font-size: 14px;
  font-weight: 400;
  width: 319px;
  height: 36px;
  line-height: 18px;
  margin-bottom: 32px;
  text-align: center;

  ${({ isMobileView }) =>
    isMobileView &&
    `
      font-size: 16px;
    `}
`;

const EmptyStateRow = styled(Row)`
  justify-content: center;
  background: ${({ theme }) => theme.colors.primaryWhite};
  padding-top: 70px;
`;

const EmptyState = ({
  image,
  title,
  description,
  buttonTitle,
  onButtonClick,
  descriptionProps = {},
  isMobileView,
  theme,
  move,
}) => {
  return (
    <EmptyStateRow id="empty-state">
      <Wrapper
        id="empty-state-wrapper"
        display="flex"
        justifyContent="center"
        flexDirection="column"
        padding="0 20px"
      >
        <Image
          id="error-image"
          src={image}
          marginBottom={52}
          maxWidth={320}
          maxHeight={226}
          width="100vw"
          height="70vh"
        />
        <Column alignItems="center">
          <TitleLabel className="title">{title}</TitleLabel>
          <DescriptionLabel
            {...descriptionProps}
            className="description"
            isMobileView={isMobileView}
          >
            {description}
          </DescriptionLabel>
          {buttonTitle && (
            <Wrapper width={'140px'}>
              <Button
                big
                secondary
                block
                padding="12px 0"
                onClick={onButtonClick}
                move
                border={move && '#023C40'}
                borderRadius={move && '32px'}
                hovercolor={move && '#E8F2EC'}
              >
                {buttonTitle}
              </Button>
            </Wrapper>
          )}
        </Column>
      </Wrapper>
    </EmptyStateRow>
  );
};

EmptyState.propTypes = {
  image: oneOfType([string, object]),
  title: string,
  description: string,
  buttonTitle: string,
  onButtonClick: func,
  descriptionProps: object,
  isMobileView: bool,
  theme: string,
  move: bool,
};

export default EmptyState;
